var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-result" }, [
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "title", "data-title": "Title" },
      },
      [
        _c("router-link", { staticClass: "company", attrs: { to: _vm.link } }, [
          _c("img", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: _vm.resource.country.name,
                expression: "resource.country.name",
              },
            ],
            staticClass: "flag",
            attrs: {
              src: _vm.resource.country.flag || "//placehold.it/24x16",
              alt: _vm.resource.country.name,
            },
          }),
          _vm._v(" "),
          _c("span", {
            class: { name: true },
            domProps: { innerHTML: _vm._s(_vm.formattedTitle) },
          }),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "deal_type", "data-title": "Deal Type" },
      },
      [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.resource.deal_type) },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "value", "data-title": "Value" },
      },
      [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.resource.deal_value) },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "sector", "data-title": "Main Sector" },
      },
      [
        _vm.sector
          ? _c("span", { staticClass: "sector" }, [
              _vm._v(_vm._s(_vm.sector.name)),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "completed", "data-title": "Completed" },
      },
      [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.resource.completed_at) },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.resource.found_highlights
      ? _c(
          "div",
          {
            staticClass: "search-result__column",
            attrs: { "data-column": "highlights" },
          },
          _vm._l(_vm.resource.found_highlights, function (highlight) {
            return _c("HighlightResult", {
              key: highlight.key,
              attrs: { resource: highlight },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }